import { GeneralStyle } from '@website-builder/model/style/general-style';

export class GalleryStyle extends GeneralStyle {
  columnGap = 'uk-grid-column-small';
  rowGap = 'uk-grid-row-small';
  dividers = '';
  imageFit = 'uk-object-cover';

  static normalize(styles: Partial<GalleryStyle>): GalleryStyle {
    const generalStyle: GeneralStyle = GeneralStyle.normalize(styles);
    const pureStyles = new GalleryStyle();

    Object.assign(pureStyles, generalStyle);

    pureStyles.columnGap = styles.columnGap ?? pureStyles.columnGap;
    pureStyles.rowGap = styles.rowGap ?? pureStyles.rowGap;
    pureStyles.dividers = styles.dividers ?? pureStyles.dividers;
    pureStyles.imageFit = styles.imageFit ?? pureStyles.imageFit;

    return pureStyles;
  }
}
